import { env } from '@skin-seoul/env-utils';

export function getMediaOrigin(): string {
  return env('NEXT_PUBLIC_ENV_MEDIA_ORIGIN') || 'https://dev-media.skin-seoul.com';
}
